import { useMediaQuery } from '../use-media-query/use-media-query.js';

function useReducedMotion(initialValue) {
  return useMediaQuery("(prefers-reduced-motion: reduce)", initialValue);
}

export { useReducedMotion };
//# sourceMappingURL=use-reduced-motion.js.map
